import { GetPickupGuideOutput } from '@allocab/allocab-commons-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { DEFAULT_CACHE_TIME, silentQueryErrorHandler } from '../services/datastore/react-query';
import { passengerApi } from '../services/network/Api';

type Input = { tripKey: string } & { jwtToken: string };

export const fetchAnonymousTripGuideDownload = async ({ tripKey, jwtToken }: Input) =>
  await passengerApi.get<Input, GetPickupGuideOutput>(`/anonymous/v1/trip/${tripKey}/pickup-guide`, undefined, {
    headers: { Authorization: `Bearer ${jwtToken}` },
  });
export const useFetchAnonymousTripGuideDownload = (jwtToken: string, tripKey: string) =>
  useQuery(
    queryKeys.fetchAnonymousTripGuideDownload(jwtToken, tripKey),
    () => fetchAnonymousTripGuideDownload({ jwtToken, tripKey }),
    {
      enabled: !!tripKey,
      staleTime: DEFAULT_CACHE_TIME,
      onError: silentQueryErrorHandler,
    },
  );
